import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { Button, Heading } from '@primer/react';
import { useGetChildrenQuery, useGetUserQuery } from '../../redux/apis/user.api';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { closeMenu, showContactForm } from '../../redux/slices/modal.slice';
import { TriangleUpIcon } from '@primer/octicons-react';
import profileIcon from '../../images/menu/profile.svg';
import logoutIcon from '../../images/menu/logout.svg';
import billing from '../../images/menu/billing.svg';
import games from '../../images/menu/games.svg';
import box from '../../images/menu/box.svg';
import howTo from '../../images/menu/howToIcon.svg';
import addToCart from '../../images/menu/add-to-cart.svg';
import chatBallon from '../../images/menu/chat-text.svg';
import emoji from '../../images/menu/emoji.svg';
import star from '../../images/menu/star.svg';
import {
  BILLING_PATH,
  LOGIN_PATH,
  MY_GAMES_PATH,
  ON_BOARDING_PATH,
  PLANS_PATH,
  PROFILE_PATH,
  REGISTRATION_PATH,
  USER_MANAGEMENT_PATH,
} from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { selectAuth } from '../../redux/slices/auth.slice';
import { isMobile } from 'react-device-detect';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import { CHANGE_MENU_WIDTH } from './AccountMenu';
import { buttonStyle } from '../../theme/theme';
import accountIcon from '../../images/accountIcon2.svg';
import membersIcon from '../../images/members.svg';
import { useLogout } from '../../hooks/useLogout';
import { useGetSubscriptionStatusQuery } from '../../redux/apis/payment';
import { setMenu } from '../../redux/slices/menu.slice';
import { CJRButton, cjrButtonStyles } from '../cjrButton/cjrButton';
import { setCookieConsentVisible } from '../../redux/slices/cookieConsent.slice';

const ClickField = styled('div')``;

// Matches the website's mobile menu items.
const Item = styled('button')`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  color: hsla(263, 50%, 12%, 0.8);
  font: 500 16px var(--font-body);
  background: white;
  border: 0px;
  cursor: pointer;
  transition: color 150ms, background-color 150ms;

  &:hover {
    color: var(--primary);
    background: var(--secondary);
  }
`;

const Icon = styled('img')`
  width: 30px;
  color: #ff7300;
  padding-right: 10px;
`;

const Image = styled('img')`
  padding-right: 14px;
  padding-top: 4px;
`;

export const BallonMenu: FunctionComponent = () => {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const logoutGlobal = useLogout();
  const { isLoggedIn, isGuest } = useAppSelector(selectAuth);
  const getUserQuery = useGetUserQuery(undefined, { skip: !isLoggedIn || isGuest });
  const sub = useGetSubscriptionStatusQuery(undefined, { skip: !isLoggedIn || isGuest });
  const dispatch = useAppDispatch();
  const show = useAppSelector((state) => state.modal.showMenu);
  const getChildren = useGetChildrenQuery(undefined, { skip: !isLoggedIn || isGuest });

  let isBallonMenu = true;
  if (width < CHANGE_MENU_WIDTH) isBallonMenu = false;

  const logout = () => {
    logoutGlobal();
    navigate(LOGIN_PATH);
  };

  if (!show) {
    return null;
  }

  return (
    <>
      {!isBallonMenu ? (
        <div
          onClick={(e) => dispatch(closeMenu())}
          style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            background: 'rgb(0, 0, 0, 0.333)',
            zIndex: 11,
          }}
        />
      ) : null}
      <ClickField
        onClick={(e) => {
          isBallonMenu && isMobile ? dispatch(closeMenu()) : null;
        }}
        onPointerLeave={(e) => {
          isBallonMenu && !isMobile ? dispatch(closeMenu()) : null;
        }}
        style={
          isBallonMenu
            ? !isMobile
              ? {
                  width: '300px',
                  //height: '100%',
                  top: '6px',
                  position: 'absolute',
                  right: '0px',
                  padding: '0px',
                  zIndex: 13,
                }
              : {
                  width: '100%',
                  height: 'calc(100% - 65px)',
                  top: '65px',
                  position: 'absolute',
                  right: '0px',
                  padding: '0px',
                  zIndex: 13,
                }
            : {}
        }
      >
        <div
          style={
            isBallonMenu
              ? {
                  top: isMobile ? '0px' : '65px',
                  paddingLeft: '14px',
                  width: '250px',
                  position: 'absolute',
                  right: '30px',
                  background: '#fff',
                  borderRadius: '30px',
                  padding: '22px',
                  boxShadow: '0px 0px 20px 0px #5555',
                  zIndex: 12,
                }
              : {
                  position: 'fixed',
                  top: '0px',
                  right: '0px',
                  padding: '25px',
                  width: '280px',
                  height: '100%',
                  background: '#fff',
                  overflow: 'hidden',
                  zIndex: 12,
                }
          }
        >
          {/* LOGGED USER MENU */}

          {isLoggedIn && !isGuest ? (
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
              {!isBallonMenu ? <Image src={accountIcon} style={{ maxHeight: '45px' }} /> : null}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Heading sx={{ fontSize: 2, textAlign: 'left', color: 'var(--primary)' }}>
                  {getUserQuery.data?.firstName}
                </Heading>
                <Heading
                  sx={{
                    fontSize: '14px',
                    lineHeight: '14px',
                    textAlign: 'left',
                    fontWeight: 400,
                    color: 'var(--primary)',
                    paddingBottom: '4px',
                  }}
                >
                  {(getUserQuery.data?.email ?? '').length > 23
                    ? getUserQuery.data?.email.slice(0, 22) + '...'
                    : getUserQuery.data?.email}
                </Heading>
              </div>
            </div>
          ) : null}

          {isLoggedIn && !isGuest && width < CHANGE_MENU_WIDTH ? (
            <>
              <Item
                onClick={() => {
                  navigate(MY_GAMES_PATH);
                  dispatch(closeMenu());
                }}
              >
                <Icon src={games} />
                Games
              </Item>
            </>
          ) : null}
          {/* 
          {width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                if (isGuest || !isLoggedIn) return dispatch(setMenu('howToPlay'));
                navigate(ON_BOARDING_PATH);
                dispatch(setMenu('onBoarding'));
                dispatch(closeMenu());
              }}
            >
              <Icon src={howTo} />
              {isGuest || !isLoggedIn ? 'Game rules' : 'How to'}
            </Item>
          ) : null} */}

          {isLoggedIn && !isGuest ? (
            <Item
              onClick={() => {
                navigate(PROFILE_PATH);
                dispatch(closeMenu());
              }}
            >
              <Icon src={profileIcon} />
              My Profile
            </Item>
          ) : null}

          {isLoggedIn &&
          !isGuest &&
          (sub.data?.find(
            (s) =>
              s.isSubscriptionActive &&
              !s.isTemporaryAddOnSubscription &&
              !s.fromParent &&
              s.allowChildren
          ) ||
            (getChildren.data?.children.length ?? 0) > 0) ? (
            <Item
              onClick={() => {
                navigate(USER_MANAGEMENT_PATH);
                dispatch(closeMenu());
              }}
            >
              <Icon src={membersIcon} />
              Manage members
            </Item>
          ) : null}

          {isLoggedIn && !isGuest ? (
            <Item
              onClick={() => {
                navigate(BILLING_PATH);
                dispatch(closeMenu());
              }}
            >
              <Icon src={sub.data?.find((s) => s.plan == 'FREE') ? box : billing} />
              {sub.data?.find((s) => s.plan == 'FREE') ? 'My plan' : 'Billings & Plans'}
            </Item>
          ) : null}

          {isLoggedIn && !isGuest && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                isLoggedIn && !isGuest
                  ? sub.data?.find(
                      (s) =>
                        s.isSubscriptionActive &&
                        !s.isTemporaryAddOnSubscription &&
                        s.plan !== 'FREE'
                    )
                    ? navigate(BILLING_PATH + '#add-ons')
                    : navigate(PLANS_PATH)
                  : navigate(PLANS_PATH);
                dispatch(closeMenu());
              }}
            >
              <Icon src={addToCart} />
              {isLoggedIn && !isGuest
                ? sub.data?.find(
                    (s) =>
                      s.isSubscriptionActive && !s.isTemporaryAddOnSubscription && s.plan !== 'FREE'
                  )
                  ? 'Add-ons'
                  : 'Upgrade'
                : 'Plans & Pricing'}
            </Item>
          ) : null}

          {isLoggedIn && !isGuest && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                dispatch(showContactForm());
                dispatch(closeMenu());
              }}
            >
              <Icon src={chatBallon} />
              Send feedback
            </Item>
          ) : null}

          {isLoggedIn && !isGuest && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                window.open('https://cozyjuicyreal.com/contact', '_blank', 'noreferrer');
                dispatch(closeMenu());
              }}
            >
              <Icon src={emoji} />
              Contact us
            </Item>
          ) : null}

          {isLoggedIn && !isGuest ? (
            <>
              {isBallonMenu ? (
                <Item onClick={logout}>
                  <Icon src={logoutIcon} />
                  Logout
                </Item>
              ) : (
                <div style={{ position: 'absolute', bottom: '0px', width: '70%', margin: '14px' }}>
                  <Button
                    onClick={logout}
                    size="medium"
                    sx={{
                      mt: 3,
                      width: '100%',
                      ...buttonStyle,
                      ...cjrButtonStyles.juicyTertiary,
                    }}
                    type="button"
                    variant="default"
                  >
                    Logout
                  </Button>
                </div>
              )}
            </>
          ) : null}

          {/* GUEST USER MENU */}

          {(!isLoggedIn || isGuest) &&
          width < CHANGE_MENU_WIDTH &&
          window.location.pathname != REGISTRATION_PATH ? (
            <Item
              onClick={() => {
                // Guests are in a game, so sign-up opens in a new tab to keep it running.
                if (isGuest) {
                  window.open(
                    `${window.location.origin}${REGISTRATION_PATH}`,
                    '_blank',
                    'noreferrer'
                  );
                } else {
                  navigate(REGISTRATION_PATH);
                }
                dispatch(closeMenu());
              }}
            >
              <CJRButton variant="juicyPrimary">
                Sign up free
              </CJRButton>
            </Item>
          ) : null}

          {!isLoggedIn && width < CHANGE_MENU_WIDTH && window.location.pathname != LOGIN_PATH ? (
            <Item
              onClick={() => {
                navigate(LOGIN_PATH);
                dispatch(closeMenu());
              }}
            >
              <CJRButton onClick={() => navigate(LOGIN_PATH)} variant="sparkTertiary">
                Login
              </CJRButton>
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                dispatch(setMenu('howToPlay'));
                dispatch(closeMenu());
              }}
            >
              <Icon src={howTo} />
              Game rules
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item onClick={() => navigate(PLANS_PATH)}>
              <Icon src={box} />
              Plans & Pricing
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => window.open('https://cozyjuicyreal.com/shop', '_blank', 'noreferrer')}
            >
              <Icon src={star} />
              Buy the board game
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                dispatch(showContactForm());
                dispatch(closeMenu());
              }}
            >
              <Icon src={chatBallon} />
              Send feedback
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() =>
                window.open('https://cozyjuicyreal.com/contact', '_blank', 'noreferrer')
              }
            >
              <Icon src={emoji} />
              Contact us
            </Item>
          ) : null}

          {(!isLoggedIn || isGuest) && width < CHANGE_MENU_WIDTH ? (
            <Item
              onClick={() => {
                localStorage.removeItem('cookieConsent');
                dispatch(setCookieConsentVisible(true));
                dispatch(closeMenu());
              }}
            >
              {/* <Icon src={emoji} /> */}
              Manage Cookies
            </Item>
          ) : null}
        </div>
        {isBallonMenu ? (
          <div
            style={{
              position: 'absolute',
              top: isMobile ? '-25px' : '40px',
              right: '60px',
              zIndex: 12,
            }}
          >
            <TriangleUpIcon fill="white" size={50} />
          </div>
        ) : null}
      </ClickField>
    </>
  );
};
